(() => {
  const selector = [
    'a[href*=".jpg"]',
    'a[href*=".png"]',
    'a[href*=".webp"]',
    'a[href*=".avif"]',
    'a[href*=".mp4"]',
    '.swinger-button-watch[data-itemnumber]',
  ].map((part) => `${part}:not([download])`).join(',');

  window.swinger.eventHub.register('click keydown', selector, (e) => {
    if (e.type === 'keydown' && e.key !== ' ') {
      return;
    }

    window.swinger.$(selector).forEach((elem) => { elem.removeAttribute('data-invoker'); });

    const target = window.swinger.eventHub.getTarget(e).closest('a,button');
    target.setAttribute('data-invoker', '');

    if (!window.swinger.user.isLoggedIn() && target.matches('[data-authentication-required]')) {
      e.preventDefault();
      return;
    }

    window.swinger.resourceLoader.preload(`${window.swinger.config.assetsBase}/widgets/media-overlay.js?v=${window.swinger.config.version}`, 'script');

    const data = target.href || target.getAttribute('data-itemnumber');
    const vr = target.getAttribute('data-vr');
    const transitionSource = target.querySelector('.swinger-image, .swinger-video-player');
    const groupElem = target.closest('nav');
    let mediaMap = {};
    let media = [data];
    let mediaIndex;

    mediaMap[data] = data;

    document.body.style.cursor = 'wait';

    if (groupElem) {
      mediaMap = window.swinger.$(selector, groupElem).reduce((acc, elem) => {
        const responsiveSources = elem.querySelector('[type="swinger/src"]');
        const href = elem.href;
        const streamId = elem.getAttribute('data-itemnumber');

        switch (true) {
          default:
            acc[href] = acc[href] || href;
            break;

          case !href && !!streamId:
            acc[streamId] = acc[streamId] || streamId;
            break;

          case responsiveSources && (typeof acc[href] === 'undefined' || typeof acc[href] === 'string'):
            acc[href] = JSON.parse(responsiveSources.textContent);
            if (acc[href].default) {
              acc[href] = acc[href].default;
            }
            break;
        }

        return acc;
      }, {});

      media = Object.keys(mediaMap).map((key, index) => {
        if (data === key) {
          mediaIndex = index;
        }

        return mediaMap[key];
      });
    }

    if (transitionSource) {
      window.swinger.transition.tag(transitionSource, 'swinger-media-overlay');
    }

    media = media.map((medium) => (typeof medium === 'string' ? medium.replace(/\/\d+x0\//, '/').replace(/\/rsz\//, '/') : medium));

    switch (true) {
      case data.indexOf('.jpg') > -1:
      case data.indexOf('.png') > -1:
      case data.indexOf('.webp') > -1:
      case data.indexOf('.avif') > -1: {
        window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:show');
        const image = new Image();
        image.addEventListener('load', () => {
          window.swinger.overlayManager.create({
            type: 'media-overlay',
            initialState: {
              media,
              mediaIndex,
              width: image.naturalWidth,
              height: image.naturalHeight,
            },
            transitionSource,
          });

          window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
        });
        image.addEventListener('error', () => {
          window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
          document.body.style.cursor = '';

          window.swinger.i18n()
            .then((i18n) => {
              window.swinger.snackbar.create({
                isSelfclosing: true,
                children: [
                  {
                    component: 'notification',
                    data: {
                      type: 'error',
                      text: i18n('ui.media-overlay.loading.error'),
                    },
                  },
                ],
              });
            })
            .catch(console.info);
        });
        image.src = data; }
        break;

      default:
      case data.indexOf('.mp4') > -1:
        window.swinger.overlayManager.create({
          type: 'media-overlay',
          initialState: {
            media,
            mediaIndex,
            width: 16,
            height: 9,
            vr,
          },
          transitionSource,
        });
        break;
    }

    e.preventDefault();
  });

  window.swinger.observer.initialize(selector, (elem) => {
    elem.setAttribute('role', 'button');
    elem.setAttribute('aria-controls', 'swinger-overlay-media-overlay');
    elem.setAttribute('aria-expanded', 'true');
    elem.setAttribute('aria-haspopup', 'dialog');
  }, false);

  window.swinger.observer.initialize([
    '.swinger-image .swinger-image__lazy-load',
    '.swinger-image img[loading="lazy"]',
  ].map((selector) => `.swinger-overlay-media-overlay .swinger-wrapper ${selector}`).join(','), (elem) => {
    const image = elem.closest('.swinger-image');

    window.requestIdleCallback(() => {
      if (
        !elem
        || !image
        || !elem.isConnected
        || !image.isConnected
      ) {
        return;
      }

      window.swinger.eventHub.trigger(image, 'swinger-image:load');
    }, {
      timeout: 3000,
    });
  }, false);
})();
